module.exports = __webpack_public_path__ + "static/assets/a0bac475b3ca72f294e58d84e85d0182.png";